var map = {
	"./gtureai.png": 3100,
	"./gturegang.png": 4138,
	"./jobbsok.png": 8827,
	"./logo.png": 6949,
	"./userImages/adne.png": 3234,
	"./userImages/knut.png": 3675,
	"./userImages/user123.png": 3323,
	"./wine.png": 6683
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;